import { render, staticRenderFns } from "./TextItemPreview.vue?vue&type=template&id=5c050339&"
import script from "./TextItemPreview.vue?vue&type=script&lang=js&"
export * from "./TextItemPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports